module.exports = "mutation RemoveGuest ($guestId: Int!) {\n  removeGuest(guestId: $guestId) {\n    id\n  }\n}\n"